import { useCallback } from 'react'
import { useQuery } from '@tanstack/react-query'

import { SellTreezService } from '@/services/sell-treez'

export const useSellTreezIndexMapping = ({
  sellTreezId,
  indexName,
}: {
  sellTreezId: string
  indexName: string
}) => {
  const queryKey = ['sell-treez-index-mapping', sellTreezId, indexName]

  const getIndexMappings = useCallback(async () => {
    const response = await SellTreezService.getSellTreezIndexMappings(sellTreezId, indexName)
    return response.data
  }, [sellTreezId, indexName])

  const { data, isLoading, refetch } = useQuery({
    queryKey,
    queryFn: getIndexMappings,
    enabled: !!indexName?.length,
  })

  return { mappings: data?.body, isLoading, refetch }
}
